import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";
import Button from "../../../Custom/Button/Button";
import deleteImg from "../../../../picture/delete.png";

const LEGAL_TEXT = `У складу са Законом о Безбедности и здрављу на раду (Сл.гл. РС бр. 35/2023), а на основу Члана 34 Програм обуке за безбедан и здрав рад послодавац обавља обуку теоријски и практично, у складу са Програмом обуке за безбедан и здрав рад који доноси послодавац. Провера теоријске и практичне обучености запосленог за безбедан и здрав рад обавља се на радном месту.`;

const styles = {
  btn: { padding: "5px 20px", fontWeight: "bold" },
  input: {
    width: "100%",
    padding: "7px 10px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "3px",
  },
  label: {
    fontWeight: "bold",
    fontSize: "13px",
    marginBottom: "4px",
    display: "block",
  },
  card: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "10px 14px",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    background: "#fff",
    cursor: "pointer",
  },
  cardSelected: {
    border: "2px solid #2196F3",
    borderRadius: "4px",
    padding: "10px 14px",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    background: "#e3f2fd",
    cursor: "pointer",
  },
};

function Zapisnik({ zaposlen, handleZatvori, onSaved }) {
  const { baseUrl, selectedMainEntity } = useGlobalContext();
  const company_id = selectedMainEntity?.company_id;

  const [katalog, setKatalog] = useState([]);
  const [custom, setCustom] = useState([]);
  const [odabrane, setOdabrane] = useState([]);
  const [tab, setTab] = useState("KATALOG");
  const [novaTema, setNovaTema] = useState("");
  const [loading, setLoading] = useState(false);
  const [datum, setDatum] = useState(new Date().toISOString().split("T")[0]);

  useEffect(() => {
    if (!company_id) return;
    axios
      .post(`${baseUrl}/zapisnik/get_teme.php`, { company_id })
      .then(({ data }) => {
        if (data.status === 200) {
          setKatalog(data.katalog || []);
          setCustom(data.custom || []);
        }
      });
  }, [company_id]);

  const toggleOdabir = (tema, izvor) => {
    const key = `${izvor}_${tema.id}`;
    setOdabrane((prev) => {
      const vec = prev.find((o) => o._key === key);
      return vec
        ? prev.filter((o) => o._key !== key)
        : [...prev, { ...tema, _key: key, _izvor: izvor }];
    });
  };

  const isOdabrana = (tema, izvor) =>
    odabrane.some((o) => o._key === `${izvor}_${tema.id}`);

  const handleSacuvajNovu = async () => {
    if (!novaTema.trim()) return;
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${baseUrl}/zapisnik/save_custom_tema.php`,
        {
          company_id,
          naziv: novaTema.trim(),
        },
      );
      if (data.status === 200) {
        setCustom((prev) => [...prev, { id: data.id, naziv: novaTema.trim() }]);
        setNovaTema("");
        setTab("CUSTOM");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleObrisiCustom = async (id) => {
    if (!window.confirm("Obrisati ovu temu?")) return;
    await axios.post(`${baseUrl}/zapisnik/delete_custom_tema.php`, {
      id,
      company_id,
    });
    setCustom((prev) => prev.filter((t) => t.id !== id));
    setOdabrane((prev) => prev.filter((o) => o._key !== `custom_${id}`));
  };

  const buildHtml = () => {
    const ime = `${zaposlen.prezime} ${zaposlen.ime}`;
    const radnoMesto = zaposlen.radnoMesto || "";
    const [y, m, d] = datum.split("-");
    const datumPrikaz = `${d}.${m}.${y}.`;

    const temeRows = odabrane
      .map(
        (t, i) => `
      <tr>
        <td class="col-rb">${i + 1}.</td>
        <td class="col-naziv">${t.naziv}</td>
        <td class="col-check"></td>
        <td class="col-check"></td>
      </tr>
    `,
      )
      .join("");

    return `<!DOCTYPE html>
<html lang="sr">
<head>
<meta charset="UTF-8"/>
<title>Записник — ${ime}</title>
<style>
  @page { size: A4 portrait; margin: 25mm 20mm 20mm 25mm; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: "Times New Roman", Times, serif; font-size: 11pt; color: #000; background: #fff; line-height: 1.4; }

  .naslov { text-align: center; font-weight: bold; font-size: 14pt; letter-spacing: 6px; margin-bottom: 0; }
  .podnaslov1 { text-align: center; font-size: 12pt; margin-top: 4pt; }
  .podnaslov2 { text-align: center; font-size: 12pt; margin-bottom: 20pt; }

  .info-blok { margin-bottom: 14pt; }
  .info-blok p { font-size: 11pt; margin-bottom: 4pt; }
  .info-linija { display: inline-block; border-bottom: 1px solid #000; min-width: 140pt; margin-left: 4pt; vertical-align: bottom; }

  .legal { font-size: 10pt; text-align: justify; margin-bottom: 16pt; text-indent: 20pt; }

  table.teme {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 14pt;
  }
  table.teme th, table.teme td {
    border: 1px solid #000;
    padding: 4pt 6pt;
    font-size: 10pt;
    vertical-align: middle;
  }
  table.teme th {
    font-weight: bold;
    text-align: center;
    font-size: 10pt;
  }
  .col-rb { width: 6%; text-align: center; }
  .col-naziv { width: 70%; }
  .col-check { width: 12%; text-align: center; }
  .rezultat-row td { font-weight: bold; font-size: 10pt; }

  .potpisi {
    display: flex;
    justify-content: space-between;
    margin-top: 30pt;
    font-size: 11pt;
  }
  .potpis-col { display: flex; flex-direction: column; gap: 12pt; }
  .potpis-linija { border-bottom: 1px solid #000; width: 140pt; margin-top: 2pt; }

  .print-btn { position: fixed; bottom: 24px; right: 24px; padding: 10px 28px; background: #1565C0; color: #fff; border: none; border-radius: 4px; font-size: 14px; font-weight: bold; cursor: pointer; box-shadow: 0 2px 10px rgba(0,0,0,0.25); z-index: 999; }
  @media print { .print-btn { display: none; } }
</style>
</head>
<body>

  <p class="naslov">З А П И С Н И К</p>
  <p class="podnaslov1">О ПРАКТИЧНОЈ ОБУЦИ</p>
  <p class="podnaslov2">ЗА БЕЗБЕДАН РАД</p>

  <div class="info-blok">
    <p>Ime и презиме : <span class="info-linija">${ime}</span></p>
    <p>Радно место : <span class="info-linija">${radnoMesto}</span></p>
    <p>Датум провере : <span class="info-linija">${datumPrikaz}</span></p>
    <p>Локација провере : <span class="info-linija"></span></p>
  </div>

  <p class="legal">${LEGAL_TEXT}</p>

  <table class="teme">
    <thead>
      <tr>
        <th class="col-rb">р.б.</th>
        <th class="col-naziv">НАЗИВ ТЕМАТСКЕ ЦЕЛИНЕ</th>
        <th class="col-check">ПОЛОЖИО</th>
        <th class="col-check">НИЈЕ ПОЛОЖИО</th>
      </tr>
    </thead>
    <tbody>
      ${temeRows}
      <tr class="rezultat-row">
        <td colspan="4" style="padding: 5pt 6pt;">РЕЗУЛТАТ ПРОВЕРЕ:</td>
      </tr>
    </tbody>
  </table>

  <div class="potpisi">
    <div class="potpis-col">
      <span>Проверу извршио:</span>
      <div class="potpis-linija"></div>
    </div>
    <div class="potpis-col">
      <span>Запослени:</span>
      <div class="potpis-linija"></div>
    </div>
  </div>

  <button class="print-btn" onclick="window.print()">🖨 Штампај</button>
</body>
</html>`;
  };

  const handleGeneriši = async () => {
    if (odabrane.length === 0) return;
    setLoading(true);

    const html = buildHtml();
    const ime = `${zaposlen.prezime} ${zaposlen.ime}`;
    const blob = new Blob([html], { type: "text/html;charset=utf-8" });
    const file = new File(
      [blob],
      `Zapisnik_${ime.replace(/\s+/g, "_")}_${datum}.html`,
      { type: "text/html" },
    );
    const datumIsteka = new Date(datum);
    datumIsteka.setFullYear(datumIsteka.getFullYear() + 2);

    const formData = new FormData();
    formData.append("employee_id", zaposlen.id);
    formData.append("naziv", "ЗАПИСНИК БЗР");
    formData.append("datum_isteka", datumIsteka.toISOString().split("T")[0]);
    formData.append("is_scan", "0");
    formData.append("file", file);

    const doSave = async (fd) => {
      const { data } = await axios.post(
        `${baseUrl}/zaposleni/create_document.php`,
        fd,
      );
      return data;
    };

    try {
      let res = await doSave(formData);
      if (res.needs_confirm) {
        if (
          !window.confirm(
            "Već postoji aktivan ЗАПИСНИК БЗР. Arhivirati stari i sačuvati novi?",
          )
        ) {
          setLoading(false);
          return;
        }
        formData.append("archive_old_id", res.old_id);
        res = await doSave(formData);
      }
      if (res.status === 200 || res.status === 201) {
        const pw = window.open("", "_blank");
        pw.document.write(html);
        pw.document.close();
        onSaved && onSaved();
        handleZatvori();
      }
    } catch (e) {
      console.error(e);
      alert("Greška pri čuvanju.");
    } finally {
      setLoading(false);
    }
  };

  const renderTemaCard = (tema, izvor) => {
    const odabrana = isOdabrana(tema, izvor);
    return (
      <div
        key={`${izvor}_${tema.id}`}
        style={odabrana ? styles.cardSelected : styles.card}
        onClick={() => toggleOdabir(tema, izvor)}
      >
        <div style={{ flex: 1, fontSize: "13px" }}>{tema.naziv}</div>
        {izvor === "custom" && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleObrisiCustom(tema.id);
            }}
            style={{ marginLeft: "8px", flexShrink: 0 }}
          >
            <img src={deleteImg} style={{ width: "20px", opacity: 0.6 }} />
          </div>
        )}
      </div>
    );
  };

  const tabStyle = (t) => ({
    padding: "6px 18px",
    fontWeight: "bold",
    cursor: "pointer",
    borderBottom: tab === t ? "3px solid #2196F3" : "3px solid transparent",
    color: tab === t ? "#2196F3" : "#555",
    fontSize: "13px",
  });

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div
        style={{
          paddingBottom: "8px",
          borderBottom: "1px solid #ddd",
          marginBottom: "10px",
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>
          Kreiranje Записника — {zaposlen.prezime} {zaposlen.ime}
        </div>
        <div style={{ fontSize: "13px", color: "#777" }}>
          {zaposlen.radnoMesto}
        </div>
      </div>

      {/* Datum + brojač */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "24px",
          marginBottom: "10px",
        }}
      >
        <div>
          <label style={styles.label}>Datum provere</label>
          <input
            type="date"
            value={datum}
            onChange={(e) => setDatum(e.target.value)}
            style={{ ...styles.input, width: "180px" }}
          />
        </div>
        <div style={{ fontSize: "14px", marginTop: "18px" }}>
          Odabrano tema: <strong>{odabrane.length}</strong>
        </div>
      </div>

      {/* Tabovi */}
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid #ddd",
          marginBottom: "10px",
        }}
      >
        <div style={tabStyle("KATALOG")} onClick={() => setTab("KATALOG")}>
          Katalog tema
        </div>
        <div style={tabStyle("CUSTOM")} onClick={() => setTab("CUSTOM")}>
          Teme firme ({custom.length})
        </div>
        <div style={tabStyle("NOVO")} onClick={() => setTab("NOVO")}>
          + Nova tema
        </div>
        {odabrane.length > 0 && (
          <div style={tabStyle("PREGLED")} onClick={() => setTab("PREGLED")}>
            Pregled ({odabrane.length})
          </div>
        )}
      </div>

      {/* Sadržaj */}
      <div style={{ flex: 1, overflowY: "auto", paddingRight: "4px" }}>
        {tab === "KATALOG" && katalog.map((t) => renderTemaCard(t, "katalog"))}

        {tab === "CUSTOM" &&
          (custom.length === 0 ? (
            <div
              style={{ color: "#aaa", padding: "20px", textAlign: "center" }}
            >
              Nema custom tema. Dodajte klikom na "+ Nova tema".
            </div>
          ) : (
            custom.map((t) => renderTemaCard(t, "custom"))
          ))}

        {tab === "NOVO" && (
          <div
            style={{
              maxWidth: "600px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div>
              <label style={styles.label}>Naziv tematske celine *</label>
              <textarea
                value={novaTema}
                onChange={(e) => setNovaTema(e.target.value)}
                rows={3}
                style={{ ...styles.input, resize: "vertical" }}
                placeholder="npr. Bezbedan rad pri korišćenju viličara"
              />
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={() => setTab("CUSTOM")}>
                <Button activation={true} style={styles.btn}>
                  Odustani
                </Button>
              </div>
              <div
                onClick={!loading ? handleSacuvajNovu : undefined}
                style={{ opacity: !novaTema.trim() ? 0.5 : 1 }}
              >
                <Button activation={true} style={styles.btn}>
                  {loading ? "..." : "Sačuvaj temu"}
                </Button>
              </div>
            </div>
          </div>
        )}

        {tab === "PREGLED" && (
          <div>
            {odabrane.map((tema, i) => (
              <div
                key={tema._key}
                style={{ ...styles.card, cursor: "default" }}
              >
                <div style={{ flex: 1, fontSize: "13px" }}>
                  {i + 1}. {tema.naziv}
                </div>
                <div
                  onClick={() =>
                    setOdabrane((prev) =>
                      prev.filter((o) => o._key !== tema._key),
                    )
                  }
                  style={{
                    cursor: "pointer",
                    color: "#e00",
                    fontSize: "20px",
                    lineHeight: 1,
                    marginLeft: "8px",
                  }}
                >
                  ×
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Dugmad */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "14px",
          paddingTop: "10px",
          borderTop: "1px solid #ddd",
        }}
      >
        <div onClick={handleZatvori}>
          <Button activation={true} style={styles.btn}>
            Odustani
          </Button>
        </div>
        <div
          onClick={!loading && odabrane.length > 0 ? handleGeneriši : undefined}
          style={{ opacity: odabrane.length === 0 || loading ? 0.5 : 1 }}
        >
          <Button
            activation={true}
            style={{
              ...styles.btn,
              backgroundColor: "#1565C0",
              color: "white",
            }}
          >
            {loading
              ? "Generišem..."
              : `Generiši zapisnik (${odabrane.length} tema)`}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Zapisnik;
